import * as React from 'react';
import styled from '@independent-software/typeui/styles/Theme'

import { Icon } from '@independent-software/typeui/controls/Icon'

import { CurrentUser } from './CurrentUser';

interface IProps {
  /** @ignore */
  className?: string;
  /** @ignore */
  children?: React.ReactNode;
  onMenu?: any;
}

const TopbarBase = (props: IProps) => {

  const handleMenu = () => {
    if(props.onMenu) props.onMenu();
  }

  return (
    <div className={props.className}>
      <div>
        <MenuIcon name="bars" onClick={handleMenu}/>
        <Title>{props.children}</Title>
      </div>
      <UserControls>
        <CurrentUser/>
      </UserControls>
    </div>
  );
}

const Title = styled.span`
  font-weight: 400;
  font-size: 24px;
  line-height: 24px;
  text-transform: uppercase;
  /* If there is a menu icon, title adds some padding. */
  &:not(:first-child) {
    padding-left: 10px;
  }
`

const MenuIcon = styled(Icon)`
  /* The menu toggle icon only shows up when
   * the screen is small. */
  display: none;
  @media (max-width: ${p => p.theme.smallScreen}px) {
    display: inline;
  }  
`

// Puts a little space between user controls
const UserControls = styled.div`
  & > *:not(:first-child) {
    padding-left: 8px;
  }
`

const Topbar = styled(TopbarBase)`
  display: flex;
  z-index: 999;
  justify-content: space-between;
  box-shadow: rgba(34, 36, 38, 0.15) 0px 0px 4px 0px;
  padding: 16px 20px 16px 20px;
  background: #fdfdfd;
`

export { Topbar };
